// Séparation des espaces : gospot.ca = site public, admin.gospot.ca = administration.
// Même backend, même base de données — le routage se fait par nom d'hôte côté frontend.
// En aperçu (preview/localhost), le sous-domaine est simulé via ?adminhost=1 (persisté en sessionStorage, ?adminhost=0 pour quitter).

export const isPreviewHost = () => {
  const h = window.location.hostname;
  return h.includes("preview.emergentagent.com") || h === "localhost" || h === "127.0.0.1";
};

export const isAdminHost = () => {
  if (window.location.hostname.startsWith("admin.")) return true;
  try {
    const flag = new URLSearchParams(window.location.search).get("adminhost");
    if (flag === "1") sessionStorage.setItem("gospot_admin_host", "1");
    if (flag === "0") sessionStorage.removeItem("gospot_admin_host");
    return isPreviewHost() && sessionStorage.getItem("gospot_admin_host") === "1";
  } catch {
    return false;
  }
};

export const adminBaseUrl = () => {
  if (isPreviewHost()) return `${window.location.origin}/?adminhost=1`;
  return `https://admin.${window.location.hostname.replace(/^www\./, "")}`;
};

export const publicBaseUrl = () => {
  if (isPreviewHost()) return `${window.location.origin}/?adminhost=0`;
  return `https://${window.location.hostname.replace(/^admin\./, "")}`;
};
